import { Icon } from '@/components/Icon';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useRunBuild } from '@/shell/RunBuildContext';
import { RunBuildAside } from './RunBuildAside';
import { RunBuildFooter } from './RunBuildFooter';
import { RunBuildFormBody } from './RunBuildFormBody';
import { useRunBuildForm } from './useRunBuildForm';

/** Screen 04 as a right sheet, 920 px wide on purpose (form + "What will happen" column; full-screen on phones): app → profile → environment → platforms → git → inputs → priority → preview → run. */
export function RunBuildSheet() {
  const { open, preset, closeRunBuild } = useRunBuild();
  return (
    <Sheet open={open} onOpenChange={(o) => (o ? undefined : closeRunBuild())}>
      <SheetContent side="right" data-testid="run-build-sheet" className="w-full gap-0 p-0 sm:max-w-[920px] lg:max-w-[920px]" aria-describedby="run-build-desc">
        {open ? <RunBuildForm key={`${preset.projectSlug ?? ''}/${preset.appId ?? ''}/${preset.profileId ?? ''}/${preset.environment ?? ''}`} /> : null}
      </SheetContent>
    </Sheet>
  );
}

function RunBuildForm() {
  const form = useRunBuildForm();
  return (
    <form data-testid="run-build-form" onSubmit={(e) => void form.onSubmit(e)} noValidate className="flex h-full min-h-0 flex-col" aria-label="Run build">
      <RunBuildHeader />
      <div className="grid min-h-0 flex-1 overflow-y-auto lg:grid-cols-[minmax(0,1fr)_340px]">
        <RunBuildFormBody form={form} />
        <RunBuildAside form={form} />
      </div>
      <RunBuildFooter form={form} />
    </form>
  );
}

function RunBuildHeader() {
  return (
    <SheetHeader className="flex-row items-center justify-start gap-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary">
        <Icon name="construction" size={20} />
      </span>
      <div className="min-w-0">
        <SheetTitle className="flex items-center gap-2">
          Run build
        </SheetTitle>
        <SheetDescription id="run-build-desc" className="truncate text-xs">
          Start a build of your app with Hangar
        </SheetDescription>
      </div>
    </SheetHeader>
  );
}
